<template>
  <div class="review-group-tournament">
    <div class="block">
      <label>Название группы</label>
      <span>{{ groupData.name }}</span>
    </div>
    <div class="block">
      <label>Слот</label>
      <span>{{ groupData.slot_count }}</span>
    </div>
    <div class="block">
      <label>Статус</label>
      <span>{{ statuses.find(({ value }) => value === groupData.status).text }}</span>
    </div>
    <div class="block">
      <label>Дата</label>
      <span>{{ gameTime }}</span>
    </div>
  </div>
</template>

<script>
import {formatTournamentDateTime} from '@/common/tournamentTime'

export default {
  name: "ReviewGroupTournament",
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      groupData: null,
      statuses: [
        {
          text: 'Игра не начата',
          value: 0
        },
        {
          text: 'Игра уже идет',
          value: 1
        },
        {
          text: 'Игра окончена',
          value: 2
        }
      ],
    }
  },
  computed: {
    /** Время группы хранится стенным в зоне турнира — показываем в локальной зоне админа. */
    gameTime() {
      const timezone = this.$store.state.moduleNewTournament.tournament?.timezone || null
      return formatTournamentDateTime(this.groupData?.game_time, timezone, {
        empty: '',
        format: {hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric'},
      })
    }
  },
  methods: {
    async getGroupData() {
      this.groupData = await this.$store.dispatch('moduleNewTournament/getGroup', {
        id: this.params.group.id
      })
    }
  },
  created() {
    this.getGroupData()
  }
}
</script>

<style scoped lang="scss">
.review-group-tournament {
  .block {
    display: flex;
    flex-direction: column;

    label {
      font-size: 17px;
      font-weight: 500;
      margin: 0;
    }

    span {
      color: gray;
    }
  }

  & > .block:not(:last-child) {
    margin-bottom: 20px;
  }
}
</style>